import { enableProdMode, ErrorHandler } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';

let env = 'develop';
if (environment.production) {
  env = 'production';
  enableProdMode();
}

Sentry.init({
  dsn: 'https://4f507522bf6b46888fc1407516b6bbe9@o333392.ingest.sentry.io/5449131',
  integrations: [
    new Integrations.BrowserTracing({
      // @see https://docs.sentry.io/platforms/javascript/performance/capturing/automatic/#tracingorigins
      tracingOrigins: [new URL(environment.api_url).hostname],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],
  environment: env,
  tracesSampleRate: 1.0,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => Sentry.captureException(err));
